import { QuestionnaireNoticeBoardTableState } from "@/Appointments/Components/Calendar/NoticeBoard/QuestionnaireNoticeBoardTable";

class NoticeBoardSearchSettings {
    public IsAllSitesChecked: boolean;
    public IsOnlySelectedSiteChecked: boolean;
    public IsAllEmployeesChecked: boolean;
    public IsAllStatusesChecked: boolean;
    public IsAllPatientContactedChecked: boolean;
    public SiteIds: string[];
    public EmployeeContactFacetIds: string[];
    public Status: string[];
    public PatientContacted: string[];
    public PageSize: number;

    public static fromModel(model: QuestionnaireNoticeBoardTableState): NoticeBoardSearchSettings {
        const settings = new NoticeBoardSearchSettings();
        settings.IsAllSitesChecked = model.isAllSitesChecked;
        settings.IsOnlySelectedSiteChecked = model.isOnlySelectedSiteChecked;
        settings.IsAllEmployeesChecked = model.isAllEmployeesChecked;
        settings.IsAllStatusesChecked = model.isAllResultsChecked;
        settings.IsAllPatientContactedChecked = model.isAllPatientContactedChecked;
        settings.SiteIds = model.allSites.filter(x => x.Checked).map(x => x.Id);
        settings.EmployeeContactFacetIds = model.allEmployees.filter(emp => emp.Checked).map(x => x.ContactFacetId);
        settings.Status = model.allResults.filter(s => s.Checked).map(s => s.Id);
        settings.PatientContacted = model.allPatientContacted.filter(x => x.Checked).map(x => x.Id);
        settings.PageSize = model.pageSize;

        return settings;
    }
}

export { NoticeBoardSearchSettings };
